import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import DayPicker from '../components/DayPicker';
import { isEqual, isBefore } from 'date-fns'

export default class DayPickerContainer extends Component {
    static propTypes = {
        id: PropTypes.string,
        placeholder: PropTypes.string,
        className: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func,
        onBlur: PropTypes.func
    };

    static defaultProps = {
        placeholder: 'dd/mm/yyyy',
        value: null,
        onChange: () => {},
        onBlur: () => {}
    };

    picker = null;
    clickedInside = false;
    clickTimeout = null;

    constructor(props) {
        super(props);
        this.state = {
            showOverlay: false,
            inputValue: this.getInputValueFromProps(props),
        };
    }

    getInputValueFromProps(props) {
        return isEmpty(props.value) ? '' : moment(props.value).format('L');
    }

    /*componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState({
                inputValue: this.getInputValueFromProps(nextProps),
            });
        }
    }*/

    componentWillUnmount() {
        clearTimeout(this.clickTimeout);
    }

    handleContainerMouseDown() {
        this.clickedInside = true;
        // The input's onBlur method is called from a queue right after onMouseDown event.
        // setTimeout adds another callback in the queue, but is called later than onBlur event
        this.clickTimeout = setTimeout(() => {
            this.clickedInside = false;
        }, 0);
    }

    handleInputFocus() {
        if (this.state.showOverlay) {
            return;
        }

        this.setState({
            showOverlay: true,
        });
    }

    handleInputBlur() {
        const showOverlay = this.clickedInside;

        // Force input's focus if blur event was caused by clicking on the calendar
        if (showOverlay) {
            this.picker.focus();
        } else {
            this.setState({
                showOverlay: false
            });
            this.props.onBlur();
        }
    }

    handleInputChange(e) {
        const { value } = e.target;
        const momentDay = moment(value, 'L', true);

        this.setState({ inputValue: value }, () => {
            if (momentDay.isValid()) {
                const dateISO = momentDay.hours(12).minutes(0).seconds(0).format();
                this.props.onChange(dateISO);
                this.picker.blur();
            } else {
                this.props.onChange(null);
            }
        });
    }

    handleDayClick(day) {
        const momentDate = moment(day);
        this.setState({
            inputValue: momentDate.format('L'),
            showOverlay: false
        }, () => {
            this.picker.blur();
            this.props.onChange(momentDate.format());
        });
    }

    toggleOverlay() {
        if (this.state.showOverlay) {
            this.picker.blur();
        } else {
            this.picker.focus();
        }
    }

    render() {
        const { id, placeholder, className, value, disabledAfter } = this.props;
        const { inputValue } = this.state;
        const inputValueMoment = moment(inputValue, 'L', true);
        const selectedDay = isEmpty(value) ? null : moment(value).toDate();

        return (
            <DayPicker
                ref={ el => { this.picker = el; } }
                handleMouseDown={::this.handleContainerMouseDown}
                className={className}
                toggleOverlay={::this.toggleOverlay}
                input={{
                    id: id,
                    placeholder: placeholder,
                    value: inputValue,
                    onChange: ::this.handleInputChange,
                    onFocus: ::this.handleInputFocus,
                    onBlur: ::this.handleInputBlur
                }}
                showPicker={this.state.showOverlay}
                picker={{
                    onDayClick: ::this.handleDayClick,
                    selected: day => isEqual(selectedDay, day),
                    disabled: day => {
                        let today = disabledAfter ? disabledAfter : new Date();
                        today.setHours(0, 0, 0, 0);
                        return  isBefore(day, today)
                    },
                    showOutsideDays: false,
                    initialMonth: inputValueMoment.isValid() ? inputValueMoment.toDate() : new Date()
                }}
            />
        );
    }
}
